import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import './OneClickProcessingPopup.scss';

class OneClickProcessingPopup extends Component {
    
    displayMessage = () => {
        let message = this.props.t("processingMessage").split('/n');
        const [heading, firstSection, link, secondSection] = message;
        return <div>
            <p className="header">{heading}</p>
            <p>{firstSection}<button className="link-text p-0" onClick={() => window.location.reload()}>{link}</button>{secondSection}</p>
        </div>
    }

    render() {
        return (
            <div className="overlay-background-min-height">
                <div className="snippetload-overlay-wrapper">
                    <div className="one-click-popup p-4">
                        <div className="consent-container p-4"> {this.displayMessage()}</div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(OneClickProcessingPopup);